import React from "react";
import { useSelector } from "react-redux";
import {
    BlockedHoc,
    ClearChatHoc, DeleteHoc, IconSingleReportHoc, UnBlockHoc, 
    // UnBlockHoc, BlockedHoc, BlockedInfoHoc,IconSingleReportHoc
  } from "../../../assets/images";
import ChatMuteOption from "./ChatMuteOption";

const BlockUnBlockOption = (props = {}) => {
  const { 
    isBlocked, 
    ClearPopupAction,
    deletePopupAction,
    popUpToggleAction, 
    handleChatMuteAction,
    reportSingleChatAction = () => { },
    featureStateData = {} 
  } = props;
  const {
    isClearChatEnabled = true,
    isDeleteChatEnabled = true,
    isBlockEnabled = true,
    isReportEnabled = true
  } = featureStateData;
  const activeChatData = useSelector((store) => store.activeChatData) || {}
  const { data:[ { chatId = "", recent: { muteStatus = 0 }  = {} } ] = {} } = activeChatData;

  return (
    <div className="contactinfo-about-no">
      {/* {(archiveStatus !== 1 || !isPermanentArchvie) ? ( */}
        <ChatMuteOption chatId={chatId} handleChatMuteAction={handleChatMuteAction} isChatMute={muteStatus === 1} />
      {/* )
        :
        <div className="text-disbaled"><BlockedInfoHoc /> <span>Archived chats are muted</span></div>
      } */}

      {isBlockEnabled && isBlocked && (
        <div data-jest-id={"jestpopUpToggleAction"} className="about-no" onClick={popUpToggleAction}>
          <i className="UnBlockIcon">
            <UnBlockHoc viewBox="0 0 18 18"/>
          </i>
          <span className="btn-block unblock">{"Unblock Contact"}</span>
        </div>
      )}

      {isBlockEnabled && !isBlocked && (
        <div data-jest-id={"jestpopUpToggleAction"} className="about-no" onClick={popUpToggleAction}>
          <i className="BlockedIcon">
            <BlockedHoc viewBox="0 0 18 18"/>
          </i>
          <span className="btn-block">{"Block Contact"}</span>
        </div>
      )}

      {isClearChatEnabled &&
        <div className="about-no" data-jest-id={"jestClearPopupAction"} onClick={ClearPopupAction}>
          <i className="deleteIcon">
            <ClearChatHoc viewBox="0 0 18 18"/>
          </i>
          <span className="delete">{"Clear Chat"}</span>
        </div>
      }

      {isDeleteChatEnabled &&
        <div data-jest-id={"jestdeletePopupAction"} className="about-no" onClick={deletePopupAction}>
          <i className="deleteIcon">
            <DeleteHoc viewBox="0 0 18.2 18.201"/>
          </i>
          <span className="delete">{"Delete Chat"}</span>
        </div>
      }

      {isReportEnabled &&
        <div data-jest-id={"jestSingleReportAction"} className="about-no" onClick={reportSingleChatAction}>
          <i className="reportIcon">
            <IconSingleReportHoc viewBox="0 0 13.726 18"/>
          </i>
          <span className="report">{"Report"}</span>
        </div>
      }
    </div>
  );
};

export default BlockUnBlockOption;
